
export default {
  name: "FormControl",
  props: ["label", "className", "containerClassName", "active"],
};
